import { FC } from 'react';
import { Helmet } from '@edikk-edikk/helmet';
import { useBaseContext } from '#base/hooks';

const Favicon: FC = () => {
  const { favicon } = useBaseContext();

  if (!favicon) {
    return null;
  }

  return (
    <Helmet>
      <link rel="icon" type="image/png" href={favicon} />
    </Helmet>
  );
};

export { Favicon };
